var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c("div", { staticClass: "header-container" }, [
                _c("div", { staticClass: "header-left" }, [
                  _c("span", { staticClass: "card-title" }, [
                    _vm._v("套餐商品列表"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "view-mode-toggle" },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: { size: "small" },
                          on: { change: _vm.handleViewModeChange },
                          model: {
                            value: _vm.viewMode,
                            callback: function ($$v) {
                              _vm.viewMode = $$v
                            },
                            expression: "viewMode",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: "list" } }, [
                            _c("i", { staticClass: "el-icon-menu" }),
                            _vm._v(" 列表模式\n                "),
                          ]),
                          _vm._v(" "),
                          _c("el-radio-button", { attrs: { label: "card" } }, [
                            _c("i", { staticClass: "el-icon-s-grid" }),
                            _vm._v(" 卡片模式\n                "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "header-right" },
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["admin:dental:product:save"],
                            expression: "['admin:dental:product:save']",
                          },
                        ],
                        staticClass: "add-product-btn",
                        attrs: {
                          type: "primary",
                          icon: "el-icon-plus",
                          size: "small",
                        },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增套餐商品")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "search-container" },
            [
              _c(
                "el-form",
                {
                  staticClass: "demo-form-inline search-form",
                  attrs: { inline: true, model: _vm.searchForm, size: "small" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "search-fields" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入商品名称关键词",
                              clearable: "",
                              "prefix-icon": "el-icon-search",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.handleSearch($event)
                              },
                            },
                            model: {
                              value: _vm.searchForm.keyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "keyword", $$v)
                              },
                              expression: "searchForm.keyword",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "供应商" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择供应商",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.searchForm.supplierId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "supplierId", $$v)
                                },
                                expression: "searchForm.supplierId",
                              },
                            },
                            _vm._l(_vm.supplierOptions, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.supplierName,
                                  value: item.id,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "状态" } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "请选择状态",
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForm.status,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "status", $$v)
                                },
                                expression: "searchForm.status",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "全部", value: "" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "上架", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "下架", value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search-buttons" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-refresh" },
                          on: { click: _vm.resetSearch },
                        },
                        [_vm._v("重置")]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.hasActiveFilters
            ? _c(
                "div",
                { staticClass: "filter-tags-container" },
                [
                  _c("span", { staticClass: "filter-tags-label" }, [
                    _vm._v("当前筛选："),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "filter-tags-group" },
                    [
                      _vm.searchForm.keyword
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "filter-tag",
                              attrs: { closable: "", size: "small" },
                              on: { close: _vm.clearKeyword },
                            },
                            [
                              _c("i", { staticClass: "el-icon-search" }),
                              _vm._v(
                                " 名称: " +
                                  _vm._s(_vm.searchForm.keyword) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.searchForm.supplierId
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "filter-tag",
                              attrs: { closable: "", size: "small" },
                              on: { close: _vm.clearSupplier },
                            },
                            [
                              _c("i", {
                                staticClass: "el-icon-office-building",
                              }),
                              _vm._v(
                                " 供应商: " +
                                  _vm._s(
                                    _vm.getSupplierName(
                                      _vm.searchForm.supplierId
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.searchForm.status !== ""
                        ? _c(
                            "el-tag",
                            {
                              staticClass: "filter-tag",
                              attrs: { closable: "", size: "small" },
                              on: { close: _vm.clearStatus },
                            },
                            [
                              _c("i", { staticClass: "el-icon-s-flag" }),
                              _vm._v(
                                " 状态: " +
                                  _vm._s(
                                    _vm.searchForm.status === 1
                                      ? "上架"
                                      : "下架"
                                  ) +
                                  "\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "clear-all-btn",
                      attrs: { size: "mini", type: "text" },
                      on: { click: _vm.resetSearch },
                    },
                    [
                      _c("i", { staticClass: "el-icon-delete" }),
                      _vm._v(" 清除筛选\n        "),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.viewMode === "list"
            ? _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    size: "small",
                    border: "",
                    "header-cell-style": {
                      background: "#f8f8f9",
                      color: "#606266",
                    },
                    "highlight-current-row": "",
                    stripe: "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "id",
                      label: "ID",
                      width: "60",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "productName",
                      label: "商品名称",
                      "min-width": "120",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    content: scope.row.productName,
                                    placement: "top-start",
                                  },
                                },
                                [
                                  _c("span", { staticClass: "product-name" }, [
                                    _vm._v(_vm._s(scope.row.productName)),
                                  ]),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1343291667
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "price",
                      label: "售价",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "price-tag" }, [
                                _vm._v("￥" + _vm._s(scope.row.price)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4018683793
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "originalPrice",
                      label: "原价",
                      width: "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "original-price" }, [
                                _vm._v("￥" + _vm._s(scope.row.originalPrice)),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      718144035
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "examPrice",
                      label: "检查费",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "materialPrice",
                      label: "材料费",
                      width: "100",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "supplierName",
                      label: "供应商",
                      width: "120",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "status",
                      label: "状态",
                      width: "80",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      scope.row.status === 1
                                        ? "success"
                                        : "info",
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.status === 1 ? "上架" : "下架"
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4182775380
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "syncStatus",
                      label: "默认加到诊所",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tag",
                                {
                                  attrs: {
                                    type:
                                      scope.row.syncStatus === 1
                                        ? "primary"
                                        : "info",
                                    size: "mini",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.syncStatus === 1 ? "是" : "否"
                                    )
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3749369267
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "创建时间",
                      width: "160",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "120",
                      align: "center",
                      fixed: "right",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "查看详情",
                                    placement: "top",
                                    effect: "light",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    attrs: {
                                      type: "primary",
                                      icon: "el-icon-view",
                                      size: "mini",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleViewDetail(scope.row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    content: "编辑",
                                    placement: "top",
                                    effect: "light",
                                  },
                                },
                                [
                                  _c("el-button", {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: ["admin:dental:product:save"],
                                        expression:
                                          "['admin:dental:product:save']",
                                      },
                                    ],
                                    attrs: {
                                      type: "success",
                                      icon: "el-icon-edit",
                                      size: "mini",
                                      circle: "",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(scope.row)
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3652230333
                    ),
                  }),
                ],
                1
              )
            : _c(
                "div",
                { staticClass: "card-view-container" },
                [
                  _vm.listLoading
                    ? _c(
                        "el-row",
                        { attrs: { gutter: 20 } },
                        _vm._l(8, function (i) {
                          return _c(
                            "el-col",
                            {
                              key: i,
                              staticClass: "card-item-col",
                              attrs: { xs: 24, sm: 12, md: 8, lg: 6, xl: 4 },
                            },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "product-card skeleton-card",
                                  attrs: {
                                    shadow: "hover",
                                    "body-style": { padding: "0px" },
                                  },
                                },
                                [
                                  _c("div", {
                                    staticClass:
                                      "product-card-image skeleton-image",
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "product-card-content" },
                                    [
                                      _c("div", {
                                        staticClass: "skeleton-title",
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "skeleton-text",
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "skeleton-price",
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "skeleton-tags",
                                      }),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass: "skeleton-status",
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "product-card-footer" },
                                        [
                                          _c("div", {
                                            staticClass: "skeleton-actions",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm.tableData && _vm.tableData.length > 0
                    ? _c(
                        "div",
                        { staticClass: "cards-grid" },
                        _vm._l(_vm.tableData, function (item) {
                          return _c(
                            "div",
                            { key: item.id, staticClass: "card-item" },
                            [
                              _c(
                                "el-card",
                                {
                                  staticClass: "product-card",
                                  attrs: {
                                    shadow: "hover",
                                    "body-style": { padding: "0px" },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "product-card-image" },
                                    [
                                      item.imageList &&
                                      item.imageList.length > 0
                                        ? _c(
                                            "el-image",
                                            {
                                              attrs: {
                                                src: item.imageList[0],
                                                fit: "cover",
                                              },
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handleImagePreview(
                                                    item.imageList
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "image-slot",
                                                  attrs: { slot: "error" },
                                                  slot: "error",
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "el-icon-picture-outline",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            { staticClass: "no-image" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "el-icon-picture-outline",
                                              }),
                                              _vm._v(" "),
                                              _c("span", [_vm._v("暂无图片")]),
                                            ]
                                          ),
                                      _vm._v(" "),
                                      item.originalPrice &&
                                      Number(item.originalPrice) >
                                        Number(item.price)
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product-card-discount",
                                            },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(
                                                    Math.round(
                                                      (1 -
                                                        Number(item.price) /
                                                          Number(
                                                            item.originalPrice
                                                          )) *
                                                        100
                                                    )
                                                  ) +
                                                  "% OFF\n              "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "product-card-content" },
                                    [
                                      _c(
                                        "h3",
                                        {
                                          staticClass: "product-card-title",
                                          attrs: { title: item.productName },
                                        },
                                        [_vm._v(_vm._s(item.productName))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "product-card-supplier",
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-office-building",
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(item.supplierName) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "product-card-price" },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "current-price" },
                                            [_vm._v("￥" + _vm._s(item.price))]
                                          ),
                                          _vm._v(" "),
                                          item.originalPrice &&
                                          Number(item.originalPrice) >
                                            Number(item.price)
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "original-price",
                                                },
                                                [
                                                  _vm._v(
                                                    "￥" +
                                                      _vm._s(item.originalPrice)
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.tagList && item.tagList.length > 0
                                        ? _c(
                                            "div",
                                            {
                                              staticClass: "product-card-tags",
                                            },
                                            [
                                              _vm._l(
                                                item.tagList,
                                                function (tag, index) {
                                                  return index < 2
                                                    ? _c(
                                                        "el-tag",
                                                        {
                                                          key: index,
                                                          staticClass:
                                                            "product-card-tag",
                                                          attrs: {
                                                            size: "mini",
                                                            effect: "plain",
                                                          },
                                                        },
                                                        [_vm._v(_vm._s(tag))]
                                                      )
                                                    : _vm._e()
                                                }
                                              ),
                                              _vm._v(" "),
                                              item.tagList.length > 2
                                                ? _c(
                                                    "el-tag",
                                                    {
                                                      staticClass:
                                                        "product-card-tag",
                                                      attrs: {
                                                        size: "mini",
                                                        effect: "plain",
                                                        type: "info",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "+" +
                                                          _vm._s(
                                                            item.tagList
                                                              .length - 2
                                                          )
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            2
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "product-card-status" },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  item.status === 1
                                                    ? "success"
                                                    : "info",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    item.status === 1
                                                      ? "已上架"
                                                      : "已下架"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                type:
                                                  item.syncStatus === 1
                                                    ? "primary"
                                                    : "info",
                                                size: "mini",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    item.syncStatus === 1
                                                      ? "默认加到诊所"
                                                      : "不默认加"
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "product-card-footer" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "product-card-actions-footer",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    type: "primary",
                                                    icon: "el-icon-view",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleViewDetail(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("查看")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  directives: [
                                                    {
                                                      name: "hasPermi",
                                                      rawName: "v-hasPermi",
                                                      value: [
                                                        "admin:dental:product:save",
                                                      ],
                                                      expression:
                                                        "['admin:dental:product:save']",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "success",
                                                    icon: "el-icon-edit",
                                                    size: "mini",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.handleEdit(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("编辑")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "product-card-actions-hover",
                                    },
                                    [
                                      _c("el-button", {
                                        attrs: {
                                          type: "primary",
                                          icon: "el-icon-view",
                                          size: "mini",
                                          circle: "",
                                          title: "查看详情",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleViewDetail(item)
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-button", {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: [
                                              "admin:dental:product:save",
                                            ],
                                            expression:
                                              "['admin:dental:product:save']",
                                          },
                                        ],
                                        attrs: {
                                          type: "success",
                                          icon: "el-icon-edit",
                                          size: "mini",
                                          circle: "",
                                          title: "编辑",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(item)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        }),
                        0
                      )
                    : _c(
                        "div",
                        { staticClass: "empty-data-container" },
                        [
                          _c(
                            "el-empty",
                            {
                              attrs: {
                                description: "暂无套餐商品数据",
                                "image-size": 200,
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["admin:dental:product:save"],
                                      expression:
                                        "['admin:dental:product:save']",
                                    },
                                  ],
                                  attrs: { type: "primary" },
                                  on: { click: _vm.handleAdd },
                                },
                                [_vm._v("添加套餐商品")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                ],
                1
              ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "current-page": _vm.searchForm.page,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.searchForm.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "update:currentPage": function ($event) {
                    return _vm.$set(_vm.searchForm, "page", $event)
                  },
                  "update:current-page": function ($event) {
                    return _vm.$set(_vm.searchForm, "page", $event)
                  },
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "dental-product-dialog",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "75%",
            "before-close": _vm.handleDialogClose,
            "close-on-click-modal": false,
            top: "3vh",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-steps",
            {
              staticStyle: { "margin-bottom": "35px", "padding-top": "10px" },
              attrs: {
                active: _vm.activeStep,
                "finish-status": "success",
                simple: "",
              },
            },
            [
              _c("el-step", {
                attrs: { title: "基础信息", icon: "el-icon-info" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "详情信息", icon: "el-icon-document" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "绑定配置", icon: "el-icon-link" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "其他设置", icon: "el-icon-setting" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 0,
                  expression: "activeStep === 0",
                },
              ],
              ref: "productForm",
              staticClass: "product-form",
              attrs: {
                model: _vm.productForm,
                rules: _vm.rules,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "div",
                { staticClass: "form-section" },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "商品名称：",
                                prop: "productName",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: { placeholder: "请输入商品名称" },
                                model: {
                                  value: _vm.productForm.productName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.productForm,
                                      "productName",
                                      $$v
                                    )
                                  },
                                  expression: "productForm.productName",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "供应商：", prop: "supplierId" },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择供应商",
                                    filterable: "",
                                    remote: "",
                                    "reserve-keyword": "",
                                    "remote-method": _vm.remoteSearchSupplier,
                                    loading: _vm.supplierLoading,
                                  },
                                  on: { change: _vm.handleSupplierChange },
                                  model: {
                                    value: _vm.productForm.supplierId,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "supplierId",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.supplierId",
                                  },
                                },
                                _vm._l(_vm.supplierOptions, function (item) {
                                  return _c("el-option", {
                                    key: item.id,
                                    attrs: {
                                      label: item.supplierName,
                                      value: item.id,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "售价：", prop: "price" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "请输入售价" },
                                  model: {
                                    value: _vm.productForm.price,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.productForm, "price", $$v)
                                    },
                                    expression: "productForm.price",
                                  },
                                },
                                [
                                  _c("template", { slot: "prepend" }, [
                                    _vm._v("￥"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "原价：", prop: "originalPrice" },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "请输入原价" },
                                  model: {
                                    value: _vm.productForm.originalPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "originalPrice",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.originalPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "prepend" }, [
                                    _vm._v("￥"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "成本价：", prop: "costPrice" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "请输入成本价" },
                                  model: {
                                    value: _vm.productForm.costPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "costPrice",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.costPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "prepend" }, [
                                    _vm._v("￥"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "材料费：",
                                prop: "materialPrice",
                              },
                            },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "请输入材料费" },
                                  model: {
                                    value: _vm.productForm.materialPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "materialPrice",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.materialPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "prepend" }, [
                                    _vm._v("￥"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "检查费：", prop: "examPrice" } },
                            [
                              _c(
                                "el-input",
                                {
                                  attrs: { placeholder: "请输入检查费" },
                                  model: {
                                    value: _vm.productForm.examPrice,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.productForm,
                                        "examPrice",
                                        $$v
                                      )
                                    },
                                    expression: "productForm.examPrice",
                                  },
                                },
                                [
                                  _c("template", { slot: "prepend" }, [
                                    _vm._v("￥"),
                                  ]),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "主图：" } }, [
                            _c("div", { staticClass: "img-upload-container" }, [
                              _c(
                                "div",
                                { staticClass: "img-upload" },
                                [
                                  _vm._l(
                                    _vm.productForm.imageList,
                                    function (item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "upload-pic",
                                        },
                                        [
                                          _c("el-image", {
                                            staticClass: "image",
                                            attrs: {
                                              src: item,
                                              fit: "contain",
                                              "preview-src-list":
                                                _vm.productForm.imageList,
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "btndel",
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  return _vm.handleRemoveImage(
                                                    index
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c("i", {
                                                staticClass: "el-icon-delete",
                                              }),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  _vm._v(" "),
                                  _vm.productForm.imageList.length < 5
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "upLoadPicBox",
                                          on: { click: _vm.modalPicTap },
                                        },
                                        [
                                          _c("div", { staticClass: "upLoad" }, [
                                            _c("i", {
                                              staticClass:
                                                "el-icon-camera cameraIconfont",
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "upload-text" },
                                              [_vm._v("添加图片")]
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "upload-info" }, [
                                _c("div", { staticClass: "upload-tip" }, [
                                  _vm._v("可上传多张主图，建议尺寸800*800像素"),
                                ]),
                                _vm._v(" "),
                                _vm.productForm.imageList.length === 0
                                  ? _c("div", { staticClass: "no-image-tip" }, [
                                      _vm._v("暂无图片，请点击上传"),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c("el-form-item", { attrs: { label: "标签：" } }, [
                            _c(
                              "div",
                              { staticClass: "tags-container" },
                              [
                                _vm._l(_vm.productForm.tagList, function (tag) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: tag,
                                      staticClass: "product-tag",
                                      attrs: {
                                        closable: "",
                                        "disable-transitions": false,
                                      },
                                      on: {
                                        close: function ($event) {
                                          return _vm.handleTagClose(tag)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(tag) +
                                          "\n                "
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.inputVisible
                                  ? _c("el-input", {
                                      ref: "saveTagInput",
                                      staticClass: "tag-input",
                                      attrs: { size: "small" },
                                      on: { blur: _vm.handleTagInputConfirm },
                                      nativeOn: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.handleTagInputConfirm(
                                            $event
                                          )
                                        },
                                      },
                                      model: {
                                        value: _vm.inputValue,
                                        callback: function ($$v) {
                                          _vm.inputValue = $$v
                                        },
                                        expression: "inputValue",
                                      },
                                    })
                                  : _c(
                                      "el-button",
                                      {
                                        staticClass: "tag-button",
                                        attrs: { size: "small" },
                                        on: { click: _vm.showTagInput },
                                      },
                                      [_vm._v("+ 添加标签")]
                                    ),
                              ],
                              2
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    { attrs: { gutter: 24 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "状态设置：" } },
                            [
                              _c(
                                "div",
                                { staticClass: "status-container" },
                                [
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "status-group",
                                      model: {
                                        value: _vm.productForm.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.productForm,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "productForm.status",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("上架"),
                                      ]),
                                      _vm._v(" "),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("下架"),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-group",
                                    {
                                      staticClass: "status-group",
                                      model: {
                                        value: _vm.productForm.syncStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.productForm,
                                            "syncStatus",
                                            $$v
                                          )
                                        },
                                        expression: "productForm.syncStatus",
                                      },
                                    },
                                    [
                                      _c("el-radio", { attrs: { label: 1 } }, [
                                        _vm._v("默认加到诊所"),
                                      ]),
                                      _vm._v(" "),
                                      _c("el-radio", { attrs: { label: 0 } }, [
                                        _vm._v("不默认加"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 1,
                  expression: "activeStep === 1",
                },
              ],
              ref: "productFormStep2",
              attrs: {
                model: _vm.productForm,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "描述：" } },
                [
                  _c("editor", {
                    ref: "descriptionEditor",
                    attrs: { sourceType: "dental", height: 400 },
                    on: { input: _vm.handleDescriptionChange },
                    model: {
                      value: _vm.productForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.productForm, "description", $$v)
                      },
                      expression: "productForm.description",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 2,
                  expression: "activeStep === 2",
                },
              ],
              ref: "productFormStep3",
              attrs: {
                model: _vm.productForm,
                "label-width": "120px",
                size: "small",
              },
            },
            [
              _c("el-form-item", { attrs: { label: "同步分销授权:" } }, [
                _c(
                  "div",
                  { staticClass: "distributor-list" },
                  _vm._l(_vm.distributorOptions, function (item) {
                    return _c(
                      "div",
                      { key: item.id, staticClass: "distributor-item" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "checkbox-wrapper",
                            class: { "is-checked": _vm.isItemChecked(item.id) },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleItemClick(item.id)
                              },
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "checkbox",
                                class: {
                                  "checkbox-checked": _vm.isItemChecked(
                                    item.id
                                  ),
                                },
                              },
                              [
                                _vm.isItemChecked(item.id)
                                  ? _c("i", { staticClass: "el-icon-check" })
                                  : _vm._e(),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "distributor-label" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.activeStep === 3,
                  expression: "activeStep === 3",
                },
              ],
              ref: "productFormStep4",
              attrs: {
                model: _vm.productForm,
                "label-width": "100px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "备注：" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 6,
                      placeholder: "请输入备注信息",
                    },
                    model: {
                      value: _vm.productForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.productForm, "remark", $$v)
                      },
                      expression: "productForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "medium" },
                  on: { click: _vm.handleDialogClose },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _vm.activeStep > 0
                ? _c(
                    "el-button",
                    { attrs: { size: "medium" }, on: { click: _vm.prevStep } },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeStep < 3
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "medium" },
                      on: { click: _vm.nextStep },
                    },
                    [_vm._v("下一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.activeStep === 3
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.submitLoading,
                      },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v("保存并完成")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("clinic-binding", {
        attrs: {
          visible: _vm.clinicBindingVisible,
          "product-id": _vm.currentProductId,
          "selected-clinic-ids": _vm.selectedClinicIds,
        },
        on: {
          "update:visible": function ($event) {
            _vm.clinicBindingVisible = $event
          },
          confirm: _vm.handleClinicBindingConfirm,
        },
      }),
      _vm._v(" "),
      _c("supplier-binding", {
        attrs: {
          visible: _vm.supplierBindingVisible,
          "product-id": _vm.currentProductId,
          "selected-supplier-ids": _vm.selectedSupplierIds,
          "product-type": 1,
        },
        on: {
          "update:visible": function ($event) {
            _vm.supplierBindingVisible = $event
          },
          confirm: _vm.handleSupplierBindingConfirm,
        },
      }),
      _vm._v(" "),
      _c("distributor-binding", {
        attrs: {
          visible: _vm.distributorBindingVisible,
          "product-id": _vm.currentProductId,
          "selected-distributor-ids": _vm.selectedDistributorIds,
        },
        on: {
          "update:visible": function ($event) {
            _vm.distributorBindingVisible = $event
          },
          confirm: _vm.handleDistributorBindingConfirm,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "套餐商品详情",
            visible: _vm.detailDialogVisible,
            width: "80%",
            "custom-class": "product-detail-dialog",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "detail-container" }, [
            _c("div", { staticClass: "detail-header" }, [
              _c("div", { staticClass: "header-left" }, [
                _c("div", { staticClass: "product-title" }, [
                  _vm._v(_vm._s(_vm.detailData.productName || "暂无名称")),
                ]),
                _vm._v(" "),
                _vm.detailData.supplierName
                  ? _c(
                      "div",
                      { staticClass: "product-supplier" },
                      [
                        _c(
                          "el-tag",
                          { attrs: { size: "small", effect: "plain" } },
                          [_vm._v(_vm._s(_vm.detailData.supplierName))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header-right" },
                [
                  _c(
                    "el-tag",
                    {
                      staticClass: "status-tag",
                      attrs: {
                        type: _vm.detailData.status === 1 ? "success" : "info",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.detailData.status === 1 ? "已上架" : "已下架"
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-tag",
                    {
                      staticClass: "status-tag",
                      staticStyle: { "margin-left": "10px" },
                      attrs: {
                        type:
                          _vm.detailData.syncStatus === 1 ? "primary" : "info",
                      },
                    },
                    [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.detailData.syncStatus === 1
                              ? "默认加到诊所"
                              : "不默认加到诊所"
                          ) +
                          "\n          "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-content-wrapper" }, [
              _c("div", { staticClass: "detail-left-column" }, [
                _vm.detailData.imageList && _vm.detailData.imageList.length > 0
                  ? _c("div", { staticClass: "detail-section" }, [
                      _c("div", { staticClass: "section-header" }, [
                        _c("i", { staticClass: "el-icon-picture" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("商品主图")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-content" }, [
                        _c(
                          "div",
                          { staticClass: "image-preview-container" },
                          _vm._l(
                            _vm.detailData.imageList,
                            function (image, index) {
                              return _c(
                                "el-image",
                                {
                                  key: index,
                                  staticClass: "preview-image",
                                  attrs: { src: image, fit: "contain" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return _vm.handleImagePreview(
                                        _vm.detailData.imageList,
                                        index
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "image-slot",
                                      attrs: { slot: "error" },
                                      slot: "error",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-picture-outline",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          1
                        ),
                      ]),
                    ])
                  : _c(
                      "div",
                      { staticClass: "empty-main-image detail-section" },
                      [
                        _c("div", { staticClass: "section-header" }, [
                          _c("i", { staticClass: "el-icon-picture" }),
                          _vm._v(" "),
                          _c("span", [_vm._v("商品主图")]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "section-content empty-image-content",
                          },
                          [
                            _c("i", { staticClass: "el-icon-picture-outline" }),
                            _vm._v(" "),
                            _c("p", [_vm._v("暂无主图")]),
                          ]
                        ),
                      ]
                    ),
                _vm._v(" "),
                _vm.detailData.tagList && _vm.detailData.tagList.length > 0
                  ? _c("div", { staticClass: "detail-section" }, [
                      _c("div", { staticClass: "section-header" }, [
                        _c("i", { staticClass: "el-icon-collection-tag" }),
                        _vm._v(" "),
                        _c("span", [_vm._v("商品标签")]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-content" }, [
                        _c(
                          "div",
                          { staticClass: "tags-container" },
                          _vm._l(_vm.detailData.tagList, function (tag) {
                            return _c(
                              "el-tag",
                              {
                                key: tag,
                                staticClass: "detail-tag",
                                attrs: { effect: "plain", type: "primary" },
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(tag) +
                                    "\n                "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "detail-right-column" }, [
                _c("div", { staticClass: "detail-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c("i", { staticClass: "el-icon-money" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("价格信息")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-content" }, [
                    _c("div", { staticClass: "price-info-table" }, [
                      _c("div", { staticClass: "price-info-row" }, [
                        _c("div", { staticClass: "price-info-label" }, [
                          _vm._v("售价："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price-info-value" }, [
                          _c("span", { staticClass: "price-highlight" }, [
                            _vm._v(
                              "￥" + _vm._s(_vm.detailData.price || "0.00")
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "price-info-row" }, [
                        _c("div", { staticClass: "price-info-label" }, [
                          _vm._v("原价："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price-info-value" }, [
                          _c("span", { staticClass: "original-price-text" }, [
                            _vm._v(
                              "￥" +
                                _vm._s(_vm.detailData.originalPrice || "0.00")
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "price-info-row" }, [
                        _c("div", { staticClass: "price-info-label" }, [
                          _vm._v("成本价："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price-info-value" }, [
                          _vm._v(
                            "￥" + _vm._s(_vm.detailData.costPrice || "0.00")
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "price-info-row" }, [
                        _c("div", { staticClass: "price-info-label" }, [
                          _vm._v("检查费："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price-info-value" }, [
                          _c("i", { staticClass: "el-icon-tickets info-icon" }),
                          _vm._v(
                            " ￥" +
                              _vm._s(_vm.detailData.examPrice || "0.00") +
                              "\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "price-info-row" }, [
                        _c("div", { staticClass: "price-info-label" }, [
                          _vm._v("材料费："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price-info-value" }, [
                          _c("i", { staticClass: "el-icon-box info-icon" }),
                          _vm._v(
                            " ￥" +
                              _vm._s(_vm.detailData.materialPrice || "0.00") +
                              "\n                  "
                          ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-section" }, [
                  _c("div", { staticClass: "section-header" }, [
                    _c("i", { staticClass: "el-icon-info" }),
                    _vm._v(" "),
                    _c("span", [_vm._v("其他信息")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "section-content" }, [
                    _c("div", { staticClass: "info-table" }, [
                      _c("div", { staticClass: "info-row" }, [
                        _c("div", { staticClass: "info-label" }, [
                          _vm._v("供应商："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-value" }, [
                          _c("i", {
                            staticClass: "el-icon-s-custom info-icon",
                          }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.detailData.supplierName || "暂无") +
                              "\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c("div", { staticClass: "info-label" }, [
                          _vm._v("供应商ID："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.detailData.supplierId || "暂无")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c("div", { staticClass: "info-label" }, [
                          _vm._v("创建时间："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-value" }, [
                          _c("i", { staticClass: "el-icon-date info-icon" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.detailData.createTime || "暂无") +
                              "\n                  "
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "info-row" }, [
                        _c("div", { staticClass: "info-label" }, [
                          _vm._v("商品ID："),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "info-value" }, [
                          _vm._v(_vm._s(_vm.detailData.id || "暂无")),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.detailData.remark
                        ? _c("div", { staticClass: "info-row" }, [
                            _c("div", { staticClass: "info-label" }, [
                              _vm._v("备注："),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "info-value" }, [
                              _c("div", { staticClass: "remark-text" }, [
                                _vm._v(_vm._s(_vm.detailData.remark)),
                              ]),
                            ]),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.detailData.description
              ? _c(
                  "div",
                  { staticClass: "detail-section description-section" },
                  [
                    _c("div", { staticClass: "section-header" }, [
                      _c("i", { staticClass: "el-icon-document" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("商品详情")]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "section-content" }, [
                      _c("div", {
                        staticClass: "description-content",
                        domProps: {
                          innerHTML: _vm._s(_vm.detailData.description),
                        },
                      }),
                    ]),
                  ]
                )
              : _c(
                  "div",
                  { staticClass: "detail-section description-section" },
                  [
                    _c("div", { staticClass: "section-header" }, [
                      _c("i", { staticClass: "el-icon-document" }),
                      _vm._v(" "),
                      _c("span", [_vm._v("商品详情")]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "section-content empty-description" },
                      [
                        _c("i", { staticClass: "el-icon-document" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("暂无商品详情")]),
                      ]
                    ),
                  ]
                ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:dental:product:save"],
                      expression: "['admin:dental:product:save']",
                    },
                  ],
                  attrs: { type: "primary", icon: "el-icon-edit" },
                  on: { click: _vm.handleEditFromDetail },
                },
                [_vm._v("编 辑")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.previewConfig.visible
        ? _c("simple-image-viewer", {
            attrs: {
              "url-list": _vm.previewConfig.urlList,
              "initial-index": _vm.previewConfig.index,
              "on-close": function () {
                return (_vm.previewConfig.visible = false)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }